<template>
  <div id="homePage">
    <Cover />
    <Intro />
    <Recent />
    <Contact />

    <!-- GDPR Snackbar -->

    <v-snackbar
      :timeout="0"
      bottom
      v-model="gdprSnackbar"
    >
      Ez a weboldal cookie-kat használ annak biztosítására, hogy a legjobb élményt nyújthassuk honlapunkon.
      <a
        href="https://firebasestorage.googleapis.com/v0/b/dragonainvest.appspot.com/o/GDPR%2Fcookie-consent.pdf?alt=media&token=bfc7cc4c-2c4f-4afd-b7d3-d8f88cbefead"
        class="snack-link"
        target="_blank"
      >További információ</a>
      <v-btn
        text
        class="heading-color"
        @click.native="setGdprCookie('allowed')"
      >Elfogadom</v-btn>
    </v-snackbar>

  </div>
</template>

<script>
import Cover from "../components/HomePage/Cover";
import Intro from "../components/HomePage/Intro";
import Recent from "../components/HomePage/Recent";
import Contact from "../components/HomePage/Contact";

export default {
  components: {
    Cover,
    Intro,
    Recent,
    Contact
  },
  data() {
    return {
      gdprSnackbar: false
    };
  },
  methods: {
    setGdprCookie: function(decision) {
      this.$cookie.set("CookieUsage", decision, 90 );
      this.$data.gdprSnackbar = false;
    },
    checkGdprCookie: function() {
      if (this.$cookie.get("CookieUsage") !== ("allowed" || "denied")) {
        this.$data.gdprSnackbar = true;
      }
    }
  },
  created: function() {
    this.checkGdprCookie();
  }
};
</script>
 
 <style scoped>
#homePage {
  min-height: 100%;
}

.heading-color {
  color: #bb9333 !important;
}

.snack-link {
  text-decoration: none;
  font-weight: bold;
  color: white;
  padding-left: 1rem;
}
</style>
 
